// extracted by mini-css-extract-plugin
export default {"social":"Social_social__iJs8y","social-links":"Social_social-links__slHSY","social-link":"Social_social-link__gH31h"};